import { Ability } from "~/lib/ability";

export class RootAbility extends Ability {
  canViewSellersJson = () => this.isAdmin();

  canViewBidders = () => this.isAdmin();
  canViewBusinessIncentives = () => this.isAdmin();
  canViewSources = () => this.isAdmin();
  canViewClients = () => this.isAdmin() || this.isManager();
  canViewPayments = () => this.isAdmin() || this.isManager();
  canViewPaymentsTrolley = () => this.isSeller() || this.isSelfServe();
  canViewAdvancedData = () => this.isSeller() || this.isSelfServe();
  canViewPaymentsTransactionHistory = () => this.isAdmin() || this.isManager();
  canViewUsers = () => this.isAdmin() || this.isManager();
  canViewCreatives = () => this.isAdmin() || this.isManager() || this.isEasybrain();
  canViewTopCreatives = () => !this.isEasybrain() && (this.isAdmin() || this.sellerId() || this.isSelfServe());
  canViewAudit = () => this.isAdmin();
  canViewAppAds = () => this.isAdmin() || this.isSeller() || this.isSelfServe();
  canViewAdminAppAds = () => !this.isSeller() && !this.isSelfServe();
  canViewPmp = () => this.isAdmin() || this.isManager();
  canViewSellerSettings = () => this.isSeller() || this.isSelfServe();
  canViewApiTokens = () => this.isAdmin();
  canViewRillAnalytics = () => this.isAdmin();
  canViewFeatures = () => this.isAdmin();
}
